var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('Container',{staticClass:"mb-12",staticStyle:{"position":"relative"},attrs:{"fluid":{ xs: true, md: false }}},[_c('Media',{class:{ 'rounded-xl elevation-2': _vm.$vuetify.breakpoint.mdAndUp },attrs:{"aspect-ratio":_vm.$vuetify.breakpoint.xs ? 1 : 4.059,"src":_vm.img
				? _vm.$vuetify.breakpoint.smAndUp
					? _vm.img
					: _vm.imgMobile
				: _vm.$vuetify.breakpoint.smAndUp
				? _vm.data.img
				: _vm.data.imgMobile}}),_c('div',{class:("form-container" + (_vm.$vuetify.breakpoint.smAndUp ? '' : '--mobile'))},[_c('NewsLetterForm')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }